export default "__VITE_ASSET__DCaWILF___"